import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../models/common";
import {
  IOffCyclePayroll,
  IOffCyclePayrollListPayload,
  IOffCyclePayrollResponse,
} from "../models";

import { IPayrollYearToDateAddEmployeePanel } from "../models/YearToDate/PayrollYearToDate/IPayrollYearToDateAddEmployeePanel";
import { format422Errors } from "../common/Common";
import http from "../common/http-commons";

export const OffCyclePayrollService = {
  getOffCyclePayroll: async (
    clientId: string,
    payPeriodFrequencyId: string | null,
    paymentType: number,
    label: string | null,
    // payPeriodEndDate: string | null,
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<
    | IOffCyclePayrollListPayload
    | IServerError
    | IResponse
    | IOffCyclePayrollResponse[]
    | null
  > => {
    if (!label) return null;
    if (payPeriodFrequencyId) {
      try {
        const response: AxiosResponse<IOffCyclePayrollListPayload> =
          await http.get<IOffCyclePayrollListPayload>(
            "/v1/payroll-off-cycle/?client_id=" +
              clientId +
              "&pay_period_frequency_id=" +
              payPeriodFrequencyId +
              "&label=" +
              label +
              "&payment_type=" +
              paymentType +
              // "&pay_period_star_date=" +
              // payPeriodStarDate +
              // "&pay_period_end_date=" +
              // payPeriodEndDate +
              "&search_query=" +
              data.search_query +
              "&order_by=" +
              data.order_by +
              "&order_direction=" +
              data.order_direction +
              "&page=" +
              data.page +
              "&size=" +
              data.size,
          );
        if (response.status === 200) {
          return response.data;
        } else if (response.status === 201) {
          return response.data;
        } else if (response.status === 400) {
          return {
            status: false,
            message: "Bad Request.",
            error: true,
          };
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    return null;

    // const fixedResponse: any = {
    //   page: 1,
    //   size: 25,
    //   rowSelection: true,
    //   total: 1,
    //   items: [
    //     {
    //       employeeName: "Tipu Sultan",
    //       employeeNumberId: "",
    //       provinceId: "67bd7102b5278a5ae5018ca3",
    //       province: {
    //         id: "67bd7102b5278a5ae5018ca3",
    //         name: "Alberta",
    //         shortCode: "AB",
    //       },
    //       dateOfHire: "2025-01-01",
    //       payPeriod: 12,
    //       payMethod: 100,
    //       salaryProfileMessage: null,
    //       td1Prov: "Exist",
    //       td1Fed: "Exist",
    //       employeeId: "69425242f639c2c0be9b2aa4",
    //       cppQppExempt: true,
    //       eiExempt: true,
    //       qpipExempt: false,
    //       federalTaxExempt: false,
    //       provisionalTaxExempt: false,
    //       hourlyRate: 2.2222222222222223,
    //       regularHoursData: 4.5,
    //       erdEarning: [],
    //       erdReimbursement: [],
    //       erdDeduction: [],
    //       commission: 0.0,
    //       retroactivePayIncrease: 0.0,
    //       nonPeriodicPayment: 0.0,
    //       bonus: 0.0,
    //       holidayPay: 0.0,
    //       holidayPayAccured: 0.0,
    //       vacationPay: 0.0,
    //       ot2Dot0Hours: null,
    //       ot1Dot5Hours: null,
    //       grossIncome: 199.0,
    //       regularHours: null,
    //       vacationPayAccured: 7.96,
    //       holidayHours: 0.0,
    //       isOffCyclePayrollCalculated: false,

    //       hourlyPayRate: 4.4,
    //       vocationable: [
    //         "regularGross",
    //         "regularHours",
    //         "vacationPay",
    //         "commission",
    //         "ot1Dot5Hours",
    //         "ot2Dot0Hours",
    //         "grossIncome",
    //         "earning",
    //       ],
    //     },
    //   ],
    //   keyField: {
    //     field: "id",
    //     templateUrl: "/offCyclePayroll/setup/id",
    //   },
    //   headerColumns: [
    //     {
    //       field: "employeeNumberId",
    //       headerName: "ID",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "text",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: false,
    //       sequence: 0,
    //       frozenColumn: true,
    //       footer: null,
    //       minWidth: null,
    //       maxWidth: 50,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "employeeName",
    //       headerName: "Name",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "text",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: false,
    //       sequence: 1,
    //       frozenColumn: true,
    //       footer: "Total",
    //       minWidth: null,
    //       maxWidth: 150,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "grossIncome",
    //       headerName: "Gross",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 2,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "regularHours",
    //       headerName: "Reg. Hours",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 3,
    //       frozenColumn: false,
    //       footer: "0.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "ot1Dot5Hours",
    //       headerName: "OT 1.5",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "ot2Dot0Hours",
    //       headerName: "OT 2.0",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "total",
    //       headerName: "Total",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "text",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: false,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 150,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "vacationPay",
    //       headerName: "Vacation Pay",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "vacationPayAccured",
    //       headerName: "Vac Due",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "text",
    //       align: "right",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "holidayHours",
    //       headerName: "Hol Hours",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "holidayPayAccured",
    //       headerName: "Hol Pay Due",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "holidayPay",
    //       headerName: "Hol Pay",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "bonus",
    //       headerName: "Bonus",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "nonPeriodicPayment",
    //       headerName: "NPP",
    //       description: "Non-Periodic Payment",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "retroactivePayIncrease",
    //       headerName: "Retro Pay",
    //       description: "Retroactive Pay Increase",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "edr",
    //     },
    //     {
    //       field: "earning",
    //       headerName: "earning",
    //       description: "",
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       type: "number",
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       isEditable: true,
    //       sequence: 4,
    //       frozenColumn: false,
    //       footer: "100.00",
    //       minWidth: null,
    //       maxWidth: 120,
    //       fieldName: null,
    //       edr: "earnings",
    //     },
    //   ],
    // };
    // return new Promise((resolve) =>
    //   setTimeout(() => resolve(fixedResponse), 1000)
    // );

    // const fixedResponse: any = {
    //   page: 1,
    //   size: 50,
    //   total: 2,
    //   items: [
    //     {
    //       employeeId: "254654351351365463436413541",
    //       id: "12",
    //       name: "Zeeshan Malik",
    //       gross: "100.00",
    //       regularHours: null,
    //       vacationPay: null,
    //       total: "100.00",
    //     },
    //     {
    //       employeeId: "254654351351365463436413541",
    //       id: "123",
    //       name: "Zeeshan Malik",
    //       gross: "100.00",
    //       regularHours: null,
    //       vacationPay: null,
    //       total: "100.00",
    //     },
    //   ],
    //   headerColumns: [
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 50,

    //       field: "id",
    //       headerName: "ID",
    //       description: "",
    //       type: "text",
    //       frozenColumn: true,
    //       sortable: false,
    //       isEditable: false,
    //       sequence: 0,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 150,

    //       field: "name",
    //       headerName: "Name",
    //       description: "",
    //       type: "text",
    //       frozenColumn: true,
    //       sortable: false,
    //       isEditable: false,
    //       sequence: 1,
    //       footer: "Total",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "gross",
    //       headerName: "Gross",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 2,
    //       footer: "100.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "regularHours",
    //       headerName: "Reg. Hours",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 3,
    //       footer: "0.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "ot1Dot5Hours",
    //       headerName: "OT 1.5",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 3,
    //       footer: "0.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "ot2Dot0Hours",
    //       headerName: "OT 2.0",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 3,
    //       footer: "0.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 150,

    //       field: "total",
    //       headerName: "Total",
    //       description: "",
    //       type: "text",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: false,
    //       sequence: 4,
    //       footer: "100.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "vacationDue",
    //       headerName: "Vac Due",
    //       description: "",
    //       type: "text",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 5,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "vacationPay",
    //       headerName: "Vac Pay",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 5,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "holidayHours",
    //       headerName: "Hol Hours",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "holidayPayDue",
    //       headerName: "Hol Pay Due",
    //       description: "",
    //       type: "text",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "holidayPay",
    //       headerName: "Hol Pay",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "bonus",
    //       headerName: "Bonus",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "nonPeriodicPayment",
    //       headerName: "Non-Periodic Payment",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "retroactivePayIncrease",
    //       headerName: "Retroactive Pay Increase",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "commission",
    //       headerName: "Commission",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "earnings",
    //       headerName: "Earnings 1",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 7,
    //       footer: null,

    //       edr: "earnings",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "deductions",
    //       headerName: "Ded",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 8,
    //       footer: null,

    //       edr: "deductions",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "reimbursements",
    //       headerName: "Reimb",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 9,
    //       footer: null,

    //       edr: "reimbursements",
    //     },
    //     // {
    //     //   flex: 1,
    //     //   hide: false,
    //     //   hideable: false,
    //     //   sortingOrder: "asc",
    //     //   resizable: false,
    //     //   align: "left",
    //     //   headerAlign: "left",
    //     //   hideSortIcons: false,
    //     //   disableColumnMenu: true,
    //     //   disableReorder: true,
    //     //   disableExport: true,
    //     //   maskable: false,
    //     //   isFixed: true,
    //     //   // maxWidth:120,

    //     //   field: "string",
    //     //   headerName: "",
    //     //   description: "",
    //     //   type: "string",
    //     //   frozenColumn: false,
    //     //   sortable: false,
    //     //   isEditable: false,
    //     //   sequence: 6,
    //     //   footer: null,
    //     // },
    //   ],
    // };
    // return new Promise((resolve) =>
    //   setTimeout(() => resolve(fixedResponse), 1000)
    // );
  },

  getCalculatedOffCyclePayroll: async (
    clientId: string,
    payPeriodFrequencyId: string | null,
    label: string | null,
    paymentType: number,
    // payPeriodEndDate: string | null,
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<
    | IOffCyclePayrollListPayload
    | IServerError
    | IResponse
    | IOffCyclePayrollResponse[]
    | any
  > => {
    if (payPeriodFrequencyId && label) {
      try {
        const response: AxiosResponse<IOffCyclePayrollListPayload> =
          await http.get<IOffCyclePayrollListPayload>(
            "/v1/payroll-off-cycle/off-cycle-caculated-payroll-data/" +
              clientId +
              "?pay_period_frequency_id=" +
              payPeriodFrequencyId +
              "&payment_type=" +
              paymentType +
              "&label=" +
              label +
              "&search_query=" +
              data.search_query +
              "&order_by=" +
              data.order_by +
              "&order_direction=" +
              data.order_direction +
              "&page=" +
              data.page +
              "&size=" +
              data.size,
          );
        if (response.status === 200) {
          return response.data;
        } else if (response.status === 201) {
          return response.data;
        } else if (response.status === 400) {
          return {
            status: false,
            message: "Bad Request.",
            error: true,
          };
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    return null;

    // const fixedResponse: any = {
    //   page: 1,
    //   size: 50,
    //   total: 2,
    //   items: [
    //     {
    //       employeeId: "254654351351365463436413541",
    //       id: "12",
    //       name: "Zeeshan Malik",
    //       gross: "100.00",
    //       regularHours: null,
    //       vacationPay: null,
    //       total: "100.00",
    //     },
    //     {
    //       employeeId: "254654351351365463436413541",
    //       id: "123",
    //       name: "Zeeshan Malik",
    //       gross: "100.00",
    //       regularHours: null,
    //       vacationPay: null,
    //       total: "100.00",
    //     },
    //   ],
    //   headerColumns: [
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 50,

    //       field: "id",
    //       headerName: "ID",
    //       description: "",
    //       type: "text",
    //       frozenColumn: true,
    //       sortable: false,
    //       isEditable: false,
    //       sequence: 0,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 150,

    //       field: "name",
    //       headerName: "Name",
    //       description: "",
    //       type: "text",
    //       frozenColumn: true,
    //       sortable: false,
    //       isEditable: false,
    //       sequence: 1,
    //       footer: "Total",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "gross",
    //       headerName: "Gross",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 2,
    //       footer: "100.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "regularHours",
    //       headerName: "Reg. Hours",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 3,
    //       footer: "0.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "ot1Dot5Hours",
    //       headerName: "OT 1.5",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 3,
    //       footer: "0.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "ot2Dot0Hours",
    //       headerName: "OT 2.0",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 3,
    //       footer: "0.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 150,

    //       field: "total",
    //       headerName: "Total",
    //       description: "",
    //       type: "text",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: false,
    //       sequence: 4,
    //       footer: "100.00",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "vacationDue",
    //       headerName: "Vac Due",
    //       description: "",
    //       type: "text",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 5,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "vacationPay",
    //       headerName: "Vac Pay",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 5,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "holidayHours",
    //       headerName: "Hol Hours",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "holidayPayDue",
    //       headerName: "Hol Pay Due",
    //       description: "",
    //       type: "text",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "holidayPay",
    //       headerName: "Hol Pay",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "bonus",
    //       headerName: "Bonus",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "nonPeriodicPayment",
    //       headerName: "Non-Periodic Payment",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "retroactivePayIncrease",
    //       headerName: "Retroactive Pay Increase",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "commission",
    //       headerName: "Commission",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 6,
    //       footer: null,
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "earnings",
    //       headerName: "Earnings 1",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 7,
    //       footer: null,

    //       edr: "earnings",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "deductions",
    //       headerName: "Ded",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 8,
    //       footer: null,

    //       edr: "deductions",
    //     },
    //     {
    //       flex: 1,
    //       hide: false,
    //       hideable: false,
    //       sortingOrder: "asc",
    //       resizable: false,
    //       align: "left",
    //       headerAlign: "left",
    //       hideSortIcons: false,
    //       disableColumnMenu: true,
    //       disableReorder: true,
    //       disableExport: true,
    //       maskable: false,
    //       isFixed: true,
    //       maxWidth: 120,

    //       field: "reimbursements",
    //       headerName: "Reimb",
    //       description: "",
    //       type: "number",
    //       frozenColumn: false,
    //       sortable: false,
    //       isEditable: true,
    //       sequence: 9,
    //       footer: null,

    //       edr: "reimbursements",
    //     },
    //     // {
    //     //   flex: 1,
    //     //   hide: false,
    //     //   hideable: false,
    //     //   sortingOrder: "asc",
    //     //   resizable: false,
    //     //   align: "left",
    //     //   headerAlign: "left",
    //     //   hideSortIcons: false,
    //     //   disableColumnMenu: true,
    //     //   disableReorder: true,
    //     //   disableExport: true,
    //     //   maskable: false,
    //     //   isFixed: true,
    //     //   // maxWidth:120,

    //     //   field: "string",
    //     //   headerName: "",
    //     //   description: "",
    //     //   type: "string",
    //     //   frozenColumn: false,
    //     //   sortable: false,
    //     //   isEditable: false,
    //     //   sequence: 6,
    //     //   footer: null,
    //     // },
    //   ],
    // };
    // return new Promise((resolve) =>
    //   setTimeout(() => resolve(fixedResponse), 1000)
    // );
  },
  getOffCyclePayrollSavedFrequency: async (
    clientId: string,
    taxYear: number,
    navigateToLogout: (path: string) => void,
  ): Promise<
    | IOffCyclePayrollListPayload
    | IServerError
    | IResponse
    | IOffCyclePayrollResponse[]
    | null
  > => {
    try {
      const response: AxiosResponse<IOffCyclePayrollListPayload> =
        await http.get<IOffCyclePayrollListPayload>(
          "/v1/offCyclePayroll/" + clientId + "/?tax_year=" + taxYear,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 201) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  create: async (
    requestPayload: any,
  ): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.post<IOffCyclePayroll>(
          "/v1/payroll-off-cycle/save/data/",
          requestPayload,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  calculate: async (
    requestPayload: any,
  ): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.post<IOffCyclePayroll>(
          "/v1/payroll-off-cycle-engine/",
          requestPayload.data,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  process: async (
    requestPayload: any,
  ): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {

    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.post<IOffCyclePayroll>(
          `/v1/billing-calculation/?client_id=${requestPayload.offCyclePayrollData.clientId}&payment_method=${requestPayload.offCyclePayrollData.paymentMethod}&client_province=${requestPayload.offCyclePayrollData.province}&tax_year=${requestPayload.offCyclePayrollData.taxYear}&pay_period_end_date=${requestPayload.offCyclePayrollData.payPeriodEndDate}&offCyclePayroll_schedule_id=${requestPayload.offCyclePayrollData.payPeriodFrequencyId}`,
          // requestPayload.data
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  directDeposit: async (
    requestPayload: any,
  ): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.post<IOffCyclePayroll>(
          `/v1/direct-deposit/for-off-cycle/?client_id=${requestPayload.clientId}&pay_period_frequency_id=${requestPayload.payPeriodFrequencyId}&pay_period_end_date=${requestPayload.payPeriodEndDate}`,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  cancelProcess: async (
    requestPayload: any,
  ): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.put<IOffCyclePayroll>(
          `/v1/transaction-log/undo_offcycle_process/${requestPayload.clientId}/undo-processes/?pay_period_end_date=${requestPayload.payPeriodEndDate}&payroll_schedule_id=${requestPayload.payPeriodFrequencyId}`,
        );

      if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  insertEmployeeOffCyclePayrollData: async (
    requestPayload: any,
  ): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.post<IOffCyclePayroll>(
          "/v1/payroll-off-cycle/inserting-data/",
          requestPayload.data,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  delEmployeeOffCyclePayrollData: async (
    delEmployeeOffCyclePayrollDataPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.put<IOffCyclePayroll>(
          "/v1/payroll-off-cycle/",
          delEmployeeOffCyclePayrollDataPayload.data,
        );

      if (response.status === 200) {
        return "Record has been deleted successfully.";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delEmployeeOffCyclePayrollDataPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  editingCalculatdeOffCyclePayroll: async ({
    clientId,
    data,
    navigateToLogout,
  }: {
    clientId: string;
    data: any;
    navigateToLogout: (path: any) => void;
  }): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.put<IOffCyclePayroll>(
          `/v1/payroll-off-cycle/${clientId}/edit/`,
          data,
        );
      if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  savingCalculatdeOffCyclePayroll: async ({
    clientId,
    data,
    navigateToLogout,
  }: {
    clientId: string;
    data: any;
    navigateToLogout: (path: any) => void;
  }): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.put<IOffCyclePayroll>(
          `/v1/payroll-off-cycle/save/${clientId}/`,
          data,
        );

      if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  overwriteCalculatdeOffCyclePayroll: async ({
    clientId,
    data,
    navigateToLogout,
  }: {
    clientId: string;
    data: any;
    navigateToLogout: (path: any) => void;
  }): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.put<IOffCyclePayroll>(
          `/v1/payroll-off-cycle/${clientId}/`,
          data,
        );

      if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getOffCyclePayrollPeriodsDDL: async (
    clientId: string,
    payPeriodId: string | null,
    taxYear: number,
  ): Promise<any | IServerError | IResponse | null | any> => {
    if (payPeriodId) {
      try {
        const response: AxiosResponse<any> = await http.get<any>(
          `/v1/payroll-schedule/ddl/for-payrol/?client_id=${clientId}&pay_period=${payPeriodId}&tax_year=${taxYear}`,
        );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 404) {
          return [];
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 404) {
          return [];
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }
    return null;
  },
  getLabelsDDL: async (
    clientId: string,
    payPeriodId: string | null,
    taxYear: number,
    paymentType: number,
  ): Promise<any | IServerError | IResponse | null | any> => {
    if (clientId) {
      try {
        const response: AxiosResponse<any> = await http.get<any>(
          `/v1/payroll-off-cycle/ddl?client_id=${clientId}&payment_type=${paymentType}`,
        );

        if (response.status === 200) {
          return response.data;
        } else if (response.status === 404) {
          return [];
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 404) {
          return [];
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }
    return null;
  },
  getVocationalEarningsList: async (
    clientId: string,
  ): Promise<any | IServerError | IResponse | null | any> => {
    // let fixed = {
    //   vocationableEarnings: {
    //     "682b1d646e7ce7f627faa331": [
    //       "regularGross",
    //       "regularHours",
    //       "vacationPay",
    //       "commission",
    //       "ot1Dot5Hours",
    //       "ot2Dot0Hours",
    //       "grossIncome",
    //     ],
    //     "69425242f639c2c0be9b2aa4": [
    //       "regularHours",
    //       "ot1Dot5Hours",
    //       "ot2Dot0Hours",
    //       "grossIncome",
    //     ],
    //   },
    //   edr: ["earning"],
    // };
    // return new Promise((resolve) => setTimeout(() => resolve(fixed), 1000));

    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/payroll-vocational-earning/get/vocational-list/?client_id=${clientId}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  createOffCyclePayrollFrequency: async (
    clientId: string,
    remittanceFrequencyId: string | undefined,
    managedBy: number,
    taxYear: number,
    navigateToLogout: (path: string) => void,
  ): Promise<IOffCyclePayroll | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IOffCyclePayroll> =
        await http.post<IOffCyclePayroll>(
          `/v1/offCyclePayroll/?client_id=${clientId}&remittance_frequency_id=${remittanceFrequencyId}&tax_year=${taxYear}&managed_by=${managedBy}`,
        );

      if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  /////////////////////////////////////////// Stub Printing OffCyclePayroll /////////////////////////////////////////////

  createStubOffCyclePayrollPdfPrint: async (
    requestPayload: any,
  ): Promise<IServerError | IResponse | any> => {
    // const requestData = {
    //   employee_id :employeeId,
    //   client_id:clientId,
    // };
    const url = `/v1/offCyclePayroll-stub-printing/?client_id=${requestPayload.clientId}`;
    const response: any = await http.post(url, requestPayload.empIds, {
      responseType: "arraybuffer",
    });
    if (response.status === 201) {
      return response.data;
    } else if (response.status === 400) {
      const text = new TextDecoder().decode(response.data);
      const responseObject = JSON.parse(text);
      let response400 = {
        ...response,
        data: responseObject,
      };
      return response400;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }
    // }
    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },

  getOffCyclePayrollAddEmployeePanel: async (
    clientId: string,
    taxYear: number,
    selectedPayPeriodId: string | undefined | null,
    payPeriodEndDate: string | undefined | null,
    paymentType: number,
    label: string,
  ): Promise<
    IPayrollYearToDateAddEmployeePanel | IServerError | IResponse | null
  > => {
    if (!selectedPayPeriodId) return null;
    const response: AxiosResponse<IPayrollYearToDateAddEmployeePanel> =
      await http.get<IPayrollYearToDateAddEmployeePanel>(
        `/v1/payroll-off-cycle/${clientId}/?payroll_shedule_id=${selectedPayPeriodId}&label=${label}&payment_type=${paymentType}`,
      );
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  assignEmployees: async (
    requestPayload: any,
  ): Promise<IServerError | IResponse | any> => {
    const response: AxiosResponse<any> = await http.post<any>(
      `/v1/payroll-off-cycle/`,
      requestPayload,
    );

    if (response.status === 201) {
      return response;
    } else if (response.status === 400) {
      return response;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  unAssignEmployees: async (
    requestPayload: any,
  ): Promise<IServerError | IResponse | any> => {
    const response: AxiosResponse<any> = await http.put<any>(
      `/v1/payroll-off-cycle/remove-data/`,
      requestPayload,
    );

    if (response.status === 201) {
      return response;
    } else if (response.status === 400) {
      return response;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
};
